import { Rule } from '@shared/interfaces/rule';
import { Observable } from 'rxjs';

export const RULES_REPOSITORY = 'RulesRepository';

export interface RulesRepository {
  url: string;

  getItems(): Observable<any>;

  add(rule: Rule): Observable<any>;

  edit(rule: Rule): Observable<any>;

  delete(item: any): Observable<any>;
}
